// extracted by mini-css-extract-plugin
export var active = "_2m-7";
export var backButton = "_2m-6";
export var clone = "_2m-c";
export var collapseBar = "_2m-h";
export var collapseMode = "_2m-j";
export var dragHandle = "_2m-a";
export var dropdownIcon = "_2m-e";
export var hidden = "_2m-p";
export var iconContainer = "_2m-m";
export var iconSwapper = "_2m-o";
export var navItem = "_2m-4";
export var navItemIcon = "_2m-d";
export var navProfile = "_2m-5";
export var notificationCountBadge = "_2m-g";
export var notificationDot = "_2m-n";
export var optionsContainer = "_2m-f";
export var primaryNav = "_2m-0";
export var primaryTab = "_2m-k";
export var secondaryNav = "_2m-1";
export var selected = "_2m-l";
export var settingsNav = "_2m-2";
export var settingsNavItems = "_2m-3";
export var show = "_2m-b";
export var sideNav = "_2m-i";
export var teamItem = "_2m-8";
export var userProfileItem = "_2m-9";